const config = {
	headers: {
		Content_Type: "application/json",
	},
};

export const getConfig = (getState) => {
	let user = getState().auth.user;
	if (user.token) {
		config.headers["x-auth-token"] = user.token;
		return config;
	}
};

export let baseUrl;

if (process.env.NODE_ENV === "production") {
	baseUrl = "https://finapp-backend-little-surf-513.fly.dev";
} else {
	baseUrl = "http://localhost:5000"; //"http://localhost:5000";
}

// http://localhost:5000
// https://stark-depths-01637.herokuapp.com
//https://lmcs-api.onrender.com/

export const formatCurrency = (amount) => {
	return new Intl.NumberFormat('en-NG', {
		style: 'currency',
		currency: 'NGN',
		minimumFractionDigits: 2
	}).format(amount);
};



export const getBalanceMappings = (isPioneer) => [
	{ code: "03010101", title: "Share Capital", type: "savings", iconClass: "bi bi-piggy-bank" },
	{ code: "02020305", title: "Ordinary Savings", type: "savings", iconClass: "bi bi-share" },
	{ code: "02010401", title: "Education Savings", type: "savings", iconClass: "bi bi-mortarboard" },
	{ code: "02010402", title: "Christmas Savings", type: "savings", iconClass: "bi bi-gift" },
	{ code: "02020301", title: "Retirement Savings", type: "savings", iconClass: "bi bi-piggy-bank" },
	{ code: isPioneer ? "01020318" : "01020310", title: "Car Loan", type: "loan", iconClass: "bi bi-car-front" },
	{ code: isPioneer ? "01020313" : "01020306", title: "1 year Normal Loan", type: "loan", iconClass: "bi bi-currency-dollar" },
	{ code: isPioneer ? "01020315" : "01020314", title: "2 year Normal Loan", type: "loan", iconClass: "bi bi-currency-dollar" },
	{ code: isPioneer ? "01020316" : "01020308", title: "Housing Loan", type: "loan", iconClass: "bi bi-house" },
	{ code: isPioneer ? "01020317" : "01020309", title: "Land Loan", type: "loan", iconClass: "bi bi-currency-dollar" },
	{ code: isPioneer ? "01020319" : "01020311", title: "Motorcycle Loan", type: "loan", iconClass: "bi bi-bicycle" },
	{ code: isPioneer ? "01020320" : "01020312", title: "Tricycle Loan", type: "loan", iconClass: "bi bi-currency-dollar" },
	{ code: isPioneer ? "01020325" : "01020307", title: "Emergency Loan", type: "loan", iconClass: "bi bi-currency-dollar" },
	{ code: isPioneer ? "01020321" : "01020301", title: "Commodity Loan", type: "loan", iconClass: "bi bi-shop-window" },
	{ code: isPioneer ? "01020322" : "01020304", title: "Electronic Purchase Loan", type: "loan", iconClass: "bi bi-currency-dollar" },
	{ code: isPioneer ? "01020324" : "01020303", title: "Office Equipment Loan", type: "loan", iconClass: "bi bi-currency-dollar" },
	{ code: isPioneer ? "01020323" : "01020302", title: "Stationary Purchase Loan", type: "loan", iconClass: "bi bi-currency-dollar" },
	{ code: "03010111", title: "Sweat Equity", type: "savings", iconClass: "bi bi-currency-dollar" },
	{ code: "03010112", title: "UNN Shares", type: "savings", iconClass: "bi bi-currency-dollar" },
	{ code: "02010405", title: "Land Development Savings", type: "savings", iconClass: "bi bi-currency-dollar" },
	{ code: "02020306", title: "SPECIAL DEPOSIT", type: "savings", iconClass: "bi bi-currency-dollar" },
	{ code: "02010322", title: "Life Assurance Claim", type: "claim", iconClass: "bi bi-shield-check" }
];

// Helper functions
export const getBalanceValue = (balance, code) => {
	const item = balance?.summary?.find(item => item.itemId?.trim() === code);
	return item ? parseFloat(item.Balance) || 0 : 0;
};

export const calculateWithdrawalSettlement = (balance, isPioneer, { applyServiceCharge = false } = {}) => {
	const mappings = getBalanceMappings(isPioneer);
	const savingsItems = mappings.filter(item => item.type === "savings").map(item => {
		let value = getBalanceValue(balance, item.code);
		if (item.code === "02020301") value *= 1.04;
		return { code: item.code, name: item.title, value };
	}).filter(item => item.value > 0);
	const claimItems = mappings.filter(item => item.type === "claim").map(item => ({
		code: item.code,
		name: item.title,
		value: getBalanceValue(balance, item.code),
	})).filter(item => item.value > 0);
	const loanItems = mappings.filter(item => item.type === "loan").map(item => ({
		code: item.code,
		name: item.title,
		value: getBalanceValue(balance, item.code),
	})).filter(item => item.value > 0);

	const totalSavings = savingsItems.reduce((sum, item) => sum + item.value, 0);
	const totalClaims = claimItems.reduce((sum, item) => sum + item.value, 0);
	const totalLoans = loanItems.reduce((sum, item) => sum + item.value, 0);
	const serviceChargeRate = applyServiceCharge ? (totalSavings < 1000000 ? 0.1 : 0.05) : 0;
	const serviceChargeAmount = totalSavings * serviceChargeRate;
	const grossEntitlement = totalSavings + totalClaims;
	const netBalance = grossEntitlement - totalLoans;

	return {
		savingsItems,
		claimItems,
		loanItems,
		totalSavings,
		totalClaims,
		grossEntitlement,
		totalLoans,
		netBalance,
		serviceChargeRate,
		serviceChargeAmount,
		amountDue: netBalance - serviceChargeAmount,
	};
};

